import React, { useEffect } from 'react';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import SocialProof from './components/SocialProof';
import CTA from './components/CTA';
import StickyBar from './components/StickyBar';
import { trackPageView, trackVisitor } from './utils/storage';
import { trackPageView as trackAnalyticsPageView } from './utils/analytics';
import { updateMetaTags, addCanonicalUrl } from './utils/seo';

function App() {
  useEffect(() => {
    // Track visitor and page view on mount
    trackVisitor();
    trackPageView();
    trackAnalyticsPageView('homepage');
    
    // Update page title and meta tags
    updateMetaTags(
      'ContaX - Never Forget Who You Met',
      'Transform every networking opportunity into lasting professional relationships. ContaX helps you remember, organize, and nurture the connections that matter most.',
      'https://mycontax.com'
    );

    // Add canonical URL
    addCanonicalUrl('https://mycontax.com');

    // Track page load performance
    if (typeof window !== 'undefined') {
      window.addEventListener('load', () => {
        const loadTime = performance.now();
        if ((window as any).clarity) {
          (window as any).clarity('set', 'page_load_time', Math.round(loadTime));
        }
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Problem />
      <Features />
      <HowItWorks />
      <SocialProof />
      <CTA />
      <StickyBar />
    </div>
  );
}

export default App;